(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('DivisionConversionDynamicReportController', DivisionConversionDynamicReportController);

    DivisionConversionDynamicReportController.$inject = ['$scope', '$state', 'DivisionConversionDynamicReport', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess', '$filter'];

    function DivisionConversionDynamicReportController ($scope, $state, DivisionConversionDynamicReport, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess, $filter) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.resetLegends = resetLegends;

        vm.exportLink = '';
        vm.UIFormAccess = UIFormAccess;

        vm.dateFilterData = {
                search: search,
                pagingParams: pagingParams,
                initCallBack: loadAll
        };

        vm.reportClean = [];
        vm.report = [];
        vm.report1 = [];
        vm.mainIdColumn = 'divisionId';
        vm.mainColumn = 'key';
        vm.totalData = {
                uniqueLeadCount: 1,
                targetedCount: 1,
                missedCount: 1,
                productCount: 1
        };

        vm.diagramOptions = {
                chart: {
                    type: 'lineChart',
                    height: 500,
                    x: function(d){return d[0];},
                    y: function(d){return d[1];},
                    duration: 300,
                    clipVoronoi: false,
                    interpolate: 'cardinal',
                    xAxis: {
                        axisLabel: 'Дата',
                        tickFormat: function(d) {
                            return d3.time.format('%d.%m.%y')(new Date(d));
                        },
                        showMaxMin: false,
                        staggerLabels: true
                    },
                    forceY: [0, 100],

                    yAxis: {
                        axisLabel: '%',
                        tickFormat: function(d){
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 20
                    }
                }
        };

        function makeLink() {
            var sortResult = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            vm.exportLink = "sort=" + sortResult
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&startDate=' + $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0))
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&endDate=' + $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0))
                    + (vm.division == null || vm.division.id == null ? '' : '&divisionId=' + vm.division.id);
        }
        makeLink();

        function loadAll () {
            makeLink();
            DivisionConversionDynamicReport.query({
                query: pagingParams.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                // search with time limits
                startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0)
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.report = data;
                vm.minData = {};
                vm.maxData = {};
                getMinMax(vm.minData, vm.maxData, data);
                for(var i = 0 ; i < vm.report.length ; i++ ) {
                    if(vm.report[i][vm.mainIdColumn] == -1) {
                        vm.totalData = vm.report[i];
                        break;
                    }
                }
            }
            function onError(error) {
                var headers = Object.keys(error.headers()).filter(function (header) {
                    return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var alertKey = error.headers(headers[0]);
                if (angular.isString(alertKey)) {
                    AlertService.warning(alertKey, { param : error.headers(headers[1])});
                }
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            vm.dateFilterData.updateDateFilterType();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                // search with time limits
                searchType: vm.dateFilterData.dateFilterType,
                startDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0) : null,
                endDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0) : null
            });
        }

        function search(searchQuery) {
            if (!searchQuery && vm.dateFilterData.dateFilterType == 'all') {
                return vm.clear();
            } else if(!searchQuery) {
                vm.currentSearch = null;
            } else {
                vm.predicate = 'name';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
            }
            vm.links = null;
            vm.page = 1;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'name';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.dateFilterData.setFilterType('all');
            vm.transition();
        }

        function resetLegends() {
            for(var i=0;i<vm.report1.length;i++) {
                if (vm.report1[i].best) {
                    vm.report1[i].disabled = false;
                } else {
                    vm.report1[i].disabled = true;
                }
            }
            vm.api.refresh();
        }
        // predefined 20 colors
        // http://tools.medialab.sciences-po.fr/iwanthue/
        // Settings: all colors + 20 colors + hard
        var colors = [[255,141,135],
            [2,195,108],
            [255,40,102],
            [1,227,206],
            [112,0,100],
            [187,255,158],
            [95,125,255],
            [255,169,4],
            [0,43,109],
            [255,140,66],
            [81,181,255],
            [155,104,0],
            [1,121,147],
            [255,197,113],
            [0,13,17],
            [211,224,255],
            [131,48,0],
            [121,112,0],
            [133,0,55],
            [68,15,0]];
        // color index
        var ci = 0;
        function getMinMax(min, max, rows) {
            // divisionId => value
            var map = new Map();
            var depMap = new Map();
            for(var i = 0 ; i < rows.length ; i++ ) {
                var row = rows[i];
                var obj = depMap.get(row['divisionId']);
                if (obj == null) {
                    obj = {
                            "key": row['name'],
                            "nameId": row['divisionId'],
                            "values": [ [ Date.parse(row['periodEnd']), row['value'], row['periodEnd'] ] ],
                            "disabled": true,
                            "best": false,
                            "color": 'rgb('+(ci < 20 ? colors[ci][0]+','+colors[ci][1]+','+colors[ci][2] : Math.floor(Math.random() * 255)+','+Math.floor(Math.random() * 255)+','+Math.floor(Math.random() * 255))+')',
                            "maxValue": row['value']
                    };
                    ci++;
                    obj.maxValue = row['value'];
                    map.set(row['divisionId'], row['value']);
                    vm.report1.push(obj);
                    depMap.set(row['divisionId'], obj)
                } else {
                    obj["values"].push([ Date.parse(row['periodEnd']), row['value'], row['periodEnd'] ]);
                    if (obj.maxValue < row['value']) {
                        map.set(row['divisionId'], row['value']);
                        obj.maxValue = row['value'];
                    }
                }
            }
            // value
            var data = [];
            // value => [divisionId,...]
            var revMap = new Map();
            map.forEach(function(v,k){
                data.push(v);
                var rk = revMap.get(k);
                if(rk == null){
                    revMap.set(v,[k]);
                } else {
                    rk.push(k);
                }
            });
            // setup max values first
            data = data.sort(function(a,b){ return b-a;});
            // show first 4 divisions
            for(var i=0;i < 4;i++) {
                revMap.get(data[i]).forEach(
                        function(dataRec){
                            var t = depMap.get(dataRec);
                            t.disabled = false;
                            t.best = true;
                        }
                );
            }
        }
    }
})();
